import React, { useState } from "react";
import { Box, Card, CardContent, TextField, Button, Typography, Alert, CircularProgress } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { login, getMe } from "../services/api";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const data = await login(email, password);
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("role", data.role);
      const me = await getMe();
      localStorage.setItem("user_name", me.data.name);
      onLogin(data.role, me.data.name);
    } catch {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "radial-gradient(ellipse at 50% 0%, rgba(99,102,241,0.15) 0%, transparent 70%), #080c14",
      position: "relative",
      overflow: "hidden"
    }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

      <Box sx={{
        position: "absolute", top: "15%", left: "50%",
        transform: "translateX(-50%)",
        width: 600, height: 600, borderRadius: "50%",
        background: "radial-gradient(circle, rgba(99,102,241,0.08) 0%, transparent 70%)",
        pointerEvents: "none"
      }} />

      <Box sx={{ width: 420, position: "relative", zIndex: 1 }}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
          <Box sx={{
            width: 52, height: 52, borderRadius: "14px",
            background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            mb: 2, boxShadow: "0 0 30px rgba(99,102,241,0.4)"
          }}>
            <AutoAwesomeIcon sx={{ fontSize: 24, color: "#fff" }} />
          </Box>
          <Typography variant="h5" fontWeight={700} color="#fff" letterSpacing="-0.5px">
            TechtideLLC
          </Typography>
          <Typography variant="body2" color="rgba(255,255,255,0.35)" mt={0.5}>
            Ops Manager — Internal Access
          </Typography>
        </Box>

        <Card sx={{
          background: "rgba(13,20,36,0.8)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(99,102,241,0.2)",
          borderRadius: "16px",
          boxShadow: "0 25px 50px rgba(0,0,0,0.5)"
        }}>
          <CardContent sx={{ p: 4 }}>
            {error && (
              <Alert severity="error" sx={{ mb: 3, borderRadius: 2, background: "rgba(239,68,68,0.1)", color: "#fca5a5", border: "1px solid rgba(239,68,68,0.2)" }}>
                {error}
              </Alert>
            )}
            <form onSubmit={handleSubmit}>
              <Typography variant="caption" color="rgba(255,255,255,0.4)" fontWeight={600} letterSpacing="0.8px" fontSize={11}>
                EMAIL ADDRESS
              </Typography>
              <TextField
                fullWidth type="email" value={email}
                onChange={e => setEmail(e.target.value)}
                required placeholder="you@storeops.com"
                sx={{
                  mt: 0.5, mb: 2.5,
                  "& .MuiOutlinedInput-root": {
                    background: "rgba(255,255,255,0.04)",
                    borderRadius: "10px",
                    "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
                    "&:hover fieldset": { borderColor: "rgba(99,102,241,0.4)" },
                    "&.Mui-focused fieldset": { borderColor: "#6366f1" },
                    "& input": { color: "#fff", fontSize: 14, py: 1.5 }
                  }
                }}
              />
              <Typography variant="caption" color="rgba(255,255,255,0.4)" fontWeight={600} letterSpacing="0.8px" fontSize={11}>
                PASSWORD
              </Typography>
              <TextField
                fullWidth type="password" value={password}
                onChange={e => setPassword(e.target.value)}
                required placeholder="••••••••"
                sx={{
                  mt: 0.5, mb: 3,
                  "& .MuiOutlinedInput-root": {
                    background: "rgba(255,255,255,0.04)",
                    borderRadius: "10px",
                    "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
                    "&:hover fieldset": { borderColor: "rgba(99,102,241,0.4)" },
                    "&.Mui-focused fieldset": { borderColor: "#6366f1" },
                    "& input": { color: "#fff", fontSize: 14, py: 1.5 }
                  }
                }}
              />
              <Button
                fullWidth type="submit" variant="contained"
                disabled={loading}
                sx={{
                  py: 1.5, borderRadius: "10px", fontWeight: 700, fontSize: 15,
                  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                  boxShadow: "0 4px 20px rgba(99,102,241,0.4)",
                  "&:hover": { boxShadow: "0 6px 25px rgba(99,102,241,0.6)" },
                  "&:disabled": { opacity: 0.6 }
                }}
              >
                {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Sign In"}
              </Button>
            </form>
          </CardContent>
        </Card>

        <Typography variant="caption" color="rgba(255,255,255,0.15)" display="block" textAlign="center" mt={3}>
          TechtideLLC — Internal Access Only
        </Typography>
      </Box>
    </Box>
  );
}
